import { useNavigate } from "react-router-dom";
import { useReveal } from "../hooks/useReveal";
import "./TrackRecord.css";

export default function TrackRecord({ data }) {
  const nav = useNavigate();
  const go = (page) => nav(page === "home" ? "/" : `/${page}`);
  const r1 = useReveal(), r2 = useReveal(), r3 = useReveal();

  return (
    <div className="tr">

      {/* HERO - dark typographic */}
      <section className="tr-hero">
        <div className="tr-hero-inner wrap">
          <div>
            <span className="tr-hero-tag">{data?.hero?.tag}</span>
            <h1 className="tr-hero-h1">
              {data?.hero?.h1?.map((line,i)=>(
                <span key={i} className={line===data?.hero?.italic?"italic":""}>{line}<br/></span>
              ))}
            </h1>
          </div>
          <div className="tr-hero-right">
            <p className="tr-hero-p">{data?.hero?.body}</p>
            <div className="tr-confidential">
              <span className="tr-conf-ico">🔒</span>
              <span>All mandates disclosed under NDA. Client identities and transaction values are protected.</span>
            </div>
          </div>
        </div>
      </section>

      {/* ACTIVE MANDATES */}
      <section className="tr-mandates" ref={r1}>
        <div className="tr-mandates-hd wrap">
          <span className="tr-section-tag rv">Ongoing Strategic Mandates</span>
          <h2 className="tr-section-h2 rv">Currently Active</h2>
        </div>
        <div className="tr-mandates-grid wrap">
          {data?.mandates?.map((m,i)=>(
            <div className="tr-mandate-card rv" key={i}>
              <div className="tr-mandate-top">
                <span className="tr-mandate-cat">{m.cat}</span>
                {m.active && <span className="tr-active-badge">● Active</span>}
              </div>
              <h3 className="tr-mandate-title">{m.title}</h3>
              <p className="tr-mandate-body">{m.body}</p>
              <div className="tr-mandate-tag">{m.tag}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ASSET PIPELINE */}
      <section className="tr-pipeline" ref={r2}>
        <div className="tr-pipeline-hd wrap">
          <span className="tr-section-tag rv">{data?.pipeline?.tag}</span>
          <h2 className="tr-section-h2 rv">{data?.pipeline?.h2}</h2>
        </div>
        <div className="tr-pipeline-table wrap rv">
          <div className="tr-table-head">
            <span>Sector</span>
            <span>Pipeline Size</span>
            <span>Active Markets</span>
          </div>
          {data?.pipeline?.items?.map((item,i)=>(
            <div className="tr-table-row" key={i}>
              <span className="tr-table-sector">{item.sector}</span>
              <span className="tr-table-size">{item.size}</span>
              <span className="tr-table-cities">{item.cities}</span>
            </div>
          ))}
        </div>
      </section>

      {/* DISCLAIMER + CTA */}
      <section className="tr-footer-sec" ref={r3}>
        <div className="tr-footer-inner wrap">
          <div className="tr-disclaimer rv">
            <span className="tr-disc-ico">⚖️</span>
            <p>{data?.disclaimer}</p>
          </div>
          <div className="tr-cta rv">
            <h3>Interested in Working With Us?</h3>
            <p>If you represent a developer, institution, or landowner with a strategic mandate — let's begin.</p>
            <button className="btn btn-r" onClick={()=>go("contact")}>Initiate a Mandate</button>
          </div>
        </div>
      </section>

    </div>
  );
}
